import react, { FC } from "react";

const Infinity: FC<{ height: string, color?: string, className?: string; style?: any } > = ({ height, color = "#ffffff", className = "", style }) => (
   <svg viewBox="0 50 200 100" height={height} xmlns="http://www.w3.org/2000/svg" className={className} style={style} >
     <path fill="none" stroke={color} strokeWidth="1" d="M100,100 C200,0 200,200 100,100 C0,0 0,200 100,100z" />
   </svg>
)

 export default Infinity;